(() => {
  // --- Helpers ---
  const pad2 = (n) => String(n).padStart(2, "0");
  const toKey = (d) => `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;

  // Gregorian Easter (Meeus/Jones/Butcher)
  function easterSunday(year) {
    const a = year % 19;
    const b = Math.floor(year / 100);
    const c = year % 100;
    const d = Math.floor(b / 4);
    const e = b % 4;
    const f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4);
    const k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31); // 3=Mar, 4=Apr
    const day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(year, month - 1, day);
  }

  function addDays(date, days) {
    const d = new Date(date);
    d.setDate(d.getDate() + days);
    return d;
  }

  // Swedish public holidays (red days)
  function swedishHolidays(year) {
    const set = new Set();

    // Fixed holidays
    const fixed = [
      [1, 1],   // Nyårsdagen
      [1, 6],   // Trettondedag jul
      [5, 1],   // Första maj
      [6, 6],   // Nationaldagen
      [12, 25], // Juldagen
      [12, 26], // Annandag jul
    ];
    fixed.forEach(([m, d]) => set.add(`${year}-${pad2(m)}-${pad2(d)}`));

    // Easter-based
    const easter = easterSunday(year);
    set.add(toKey(addDays(easter, -2))); // Långfredagen
    set.add(toKey(addDays(easter, 1)));  // Annandag påsk
    set.add(toKey(addDays(easter, 39))); // Kristi himmelsfärd

    // Midsummer Day: Saturday between Jun 20–26
    {
      const start = new Date(year, 5, 20);
      for (let x = 0; x < 7; x++) {
        const d = addDays(start, x);
        if (d.getDay() === 6) {
          set.add(toKey(d));
          break;
        }
      }
    }

    // All Saints' Day: Saturday between Oct 31–Nov 6
    {
      const start = new Date(year, 9, 31);
      for (let x = 0; x < 7; x++) {
        const d = addDays(start, x);
        if (d.getDay() === 6) {
          set.add(toKey(d));
          break;
        }
      }
    }

    return set;
  }

  function isBusinessDay(date, holidaysByYear) {
    const day = date.getDay(); // 0 Sun, 6 Sat
    if (day === 0 || day === 6) return false;
    const y = date.getFullYear();
    const key = toKey(date);
    return !holidaysByYear.get(y).has(key);
  }

  // Add N business days ahead, excluding "today"
  function addBusinessDays(fromDate, n, holidaysByYear) {
    let d = new Date(fromDate);
    let count = 0;
    while (count < n) {
      d = addDays(d, 1);
      if (isBusinessDay(d, holidaysByYear)) count++;
    }
    return d;
  }

  const monthsSv = ["jan", "feb", "mar", "apr", "maj", "jun", "jul", "aug", "sep", "okt", "nov", "dec"];

  function formatRange(d1, d2) {
    const day1 = d1.getDate();
    const day2 = d2.getDate();
    const m1 = monthsSv[d1.getMonth()];
    const m2 = monthsSv[d2.getMonth()];

    if (toKey(d1) === toKey(d2)) return `${day1} ${m1}`;
    if (d1.getMonth() === d2.getMonth()) return `${day1}–${day2} ${m1}`;
    return `${day1} ${m1}–${day2} ${m2}`;
  }

  // Replace tokens in a string:
  //  - %%DELIVERY_7_10%%  -> "8–12 jan"
  //  - %DELIVERY_7_10%    -> "8–12 jan"
  function replaceDeliveryTokens(text) {
    if (!text || typeof text !== "string") return text;

    const now = new Date();
    const yearsNeeded = new Set([now.getFullYear(), now.getFullYear() + 1]);
    const holidaysByYear = new Map();
    yearsNeeded.forEach((y) => holidaysByYear.set(y, swedishHolidays(y)));

    // Match both %...% and %%...%%
    return text.replace(/%{1,2}DELIVERY_(\d+)_(\d+)%{1,2}/g, (full, minStr, maxStr) => {
      const min = parseInt(minStr, 10);
      const max = parseInt(maxStr, 10);

      if (!Number.isFinite(min) || !Number.isFinite(max) || min < 0 || max < min) return full;

      const start = addBusinessDays(now, min, holidaysByYear);
      const end = addBusinessDays(now, max, holidaysByYear);
      return formatRange(start, end);
    });
  }

  // Apply to nodes (text content)
  function applyToElement(el) {
    const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    let node;
    while ((node = walker.nextNode())) {
      const original = node.nodeValue;
      if (original && original.includes("DELIVERY_")) {
        node.nodeValue = replaceDeliveryTokens(original);
      }
    }
  }

  function run() {
    applyToElement(document.body);

    const obs = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.type === "childList") {
          m.addedNodes.forEach((n) => {
            // TEXT-nod
            if (n.nodeType === 3) {
              const txt = n.nodeValue || "";
              if (txt.includes("DELIVERY_")) {
                n.nodeValue = replaceDeliveryTokens(txt);
              }
              return;
            }

            // ELEMENT-nod
            if (n.nodeType === 1) {
              applyToElement(n);
            }
          });
        } else if (m.type === "characterData") {
          const txt = m.target.nodeValue || "";
          if (txt.includes("DELIVERY_")) {
            m.target.nodeValue = replaceDeliveryTokens(txt);
          }
        }
      }
    });

    obs.observe(document.body, {
      subtree: true,
      childList: true,
      characterData: true,
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }
})();